import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Projects.css';
import HighlightedTitle from '../components/HighlightedTitle';
import ProjectPage from '../components/ProjectPage';

function DesignProjects() {
  const [imageLoaded, setImageLoaded] = useState(
    new Array(5).fill(false) // Initialize an array for 5 projects, all set to false (not loaded)
  );
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: 'Prelapsarian Design',
      date: '2025',
      summary: 'Movie Poster & Social Media Designs',
      images: [{ type: "image", url: '/project_images/prelapsarian1.jpeg' }],
      placeholder: '/project_images/prelapsarian1.jpeg',
    },
    {
      title: 'Priests Can’t Date',
      date: '2025',
      summary: 'Movie Poster & Social Media Designs',
      images: [{ type: "image", url: '/project_images/priestscantdate.jpeg' }],
      placeholder: '/project_images/priestscantdate.jpeg',
    },
    {
      title: 'You First',
      date: '2025',
      summary: 'Movie Poster & Social Media Designs',
      images: [{ type: "image", url: '/project_images/youfirst2.PNG' }],
      placeholder: '/project_images/youfirst2.PNG',
    },
    {
      title: 'While We’ve Still Got Feet',
      date: '2024',
      summary: "Poster design for While We've Still Got Feet, a short film exploring grief, generational bonds, and the transformative power of caregiving. Inspired by the AIDS epidemic's legacy and intergenerational connection, the design captures the film's emotional depth and vibrant spirit.",
      images: [{ type: "image", url: '/project_images/while-weve-still-got-feet-main.png' },
        { type: "image", url: '/project_images/while-weve-still-got-feet3.jpeg' },
        { type: "image", url: '/project_images/while-weve-still-got-feet4.jpeg' },
        { type: "image", url: '/project_images/while-weve-still-got-feet5.jpeg' },
        { type: "image", url: '/project_images/while-weve-still-got-feet6.jpeg' },
        {type: "video", url: "https://www.youtube.com/watch?v=5wP6i1Az0wg"}],
      placeholder: '/project_images/while-weve-still-got-feet-main.png',
      awards: [
        "Finalist Films Infest NYCIFIF 2024",
        "Official Selection Cannes Indie Shorts Award 2024",
        "Official Selection New York International Film Awards 2024",
        "Official Selection Indie Short Fest 2024"
      ],
    },
    // Add more projects as needed
  ];

  const handleImageLoad = (index) => {
    setImageLoaded((prev) => {
      const newLoadedState = [...prev];
      newLoadedState[index] = true; // Mark image as loaded
      return newLoadedState;
    });
  };

  return (
    <AnimatePresence mode="wait">
      {selectedProject ? (
        <motion.div
          key="projectPage"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
        >
          <ProjectPage project={selectedProject} onBack={() => setSelectedProject(null)} />
        </motion.div>
      ) : (
        <motion.div
          key="projectList"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ duration: 0.5 }}
        >
          <div className="projects-container">
            {projects.map((project, index) => (
              <div
                key={index}
                className={`project-item ${index % 2 === 0 ? 'left-first' : 'right-first'}`}
                onClick={() => setSelectedProject(project)}
              >
                <div className="project-image">
                  <img
                    src={imageLoaded[index] ? project.images[0].url : project.placeholder} // Use the url property from the image object
                    alt={project.title}
                    className="project-image"
                    onLoad={() => handleImageLoad(index)} // Call handleImageLoad when image loads
                    loading="lazy" // Lazy load for better performance
                  />
                </div>
                <div className="project-text">
                  <div className="project-title">
                    <HighlightedTitle text={project.title} />
                    <p>{project.date}</p>
                  </div>
                  <p className="project-summary">{project.summary}</p>
                  {/* If project has awards, display them */}
                  {project.awards && project.awards.map((award, i) => (
                    <p key={i} className="project-award">{award}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default DesignProjects;